import { createBreakpointHelpers } from '../utils/breakpoints';
export function createTheme(theme) {
    return Object.assign(Object.assign({}, createBreakpointHelpers(theme.default.breakpoints)), theme.default);
}
//# sourceMappingURL=createTheme.js.map